export const SESSION_EXPIRED_MESSAGE = 'Session expired. Log in again.';
export const SESSION_INVALID_MESSAGE = 'Session is invalid. Log in again.';

export const formatFailedActionMessage = (action, target = '') => {
  const normalizedAction = String(action || '').trim();
  const normalizedTarget = String(target || '').trim();
  const suffix = normalizedTarget ? ` ${normalizedTarget}` : '';
  return `Failed to ${normalizedAction}${suffix}`;
};

export const formatSuccessActionMessage = (action, target = '') => {
  const normalizedAction = String(action || '').trim();
  const normalizedTarget = String(target || '').trim();
  const prefix = normalizedTarget ? `${normalizedTarget} ` : '';
  return `${prefix}${normalizedAction} successfully`;
};

